import { useState, useRef } from 'react'
import Box from '@mui/joy/Box'
import Slider from '@mui/joy/Slider'
import { MenuDropdown } from './ui/MenuDropdown'

export const TransparencySlider = ({ opacity, onChange }) => {
    const startOpacity = useRef(opacity)

    return (
        <MenuDropdown label="Transparency">
            <Box
                sx={{
                    display: 'flex',
                    width: 200,
                    justifyItems: 'center',
                    p: 1,
                }}
            >
                <Slider
                    color="neutral"
                    defaultValue={startOpacity.current}
                    onChange={onChange}
                    step={1}
                    min={0}
                    max={100}
                    size="md"
                    valueLabelDisplay="on"
                    variant="soft"
                />
            </Box>
        </MenuDropdown>
    )
}
